const carouselItems = [
  {
    title: '斗破苍穹：三年之约终极对决',
    desc: '萧炎踏上云岚宗，赴三年之约。佛怒火莲焚尽一切，药老灵魂苏醒，加玛帝国最强之战一触即发。完整版全卷一次看完，下拉阅读不停歇。',
    tag: '玄幻热血',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20epic%20fantasy%20battle%20scene%20with%20a%20young%20warrior%20surrounded%20by%20flames%2C%20ancient%20Chinese%20palace%20in%20background%2C%20dramatic%20fire%20and%20energy%20effects%2C%20Chinese%20manhua%20style%2C%20warm%20orange%20and%20gold%20lighting%2C%20cinematic%20widescreen%20composition%2C%20epic%20scale&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '全职高手：荣耀之巅叶修归来',
    desc: '君莫笑横空出世，散人玩法震惊荣耀圈。从网吧到职业赛场，叶修用实力书写电竞传奇。漫画完结版全卷完整收录，下拉即可畅读。',
    tag: '电竞热血',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20cyberpunk%20esports%20arena%20with%20holographic%20displays%20and%20a%20cool%20gamer%20in%20the%20center%2C%20futuristic%20gaming%20atmosphere%2C%20Chinese%20manhua%20style%2C%20blue%20and%20orange%20neon%20lighting%2C%20dramatic%20crowd%20cheering%20scene%2C%20wide%20cinematic%20composition&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '魔道祖师：魏无羡重生归来',
    desc: '夷陵老祖重现世间，姑苏蓝氏含光君携手追查真相。古风玄幻悬疑巨制，漫画完整版全卷一次看完，经典不言而喻。',
    tag: '古风玄幻',
    imageUrl: 'https://readdy.ai/api/search-image?query=An%20elegant%20ancient%20Chinese%20fantasy%20scene%20with%20two%20figures%20in%20flowing%20robes%20under%20moonlight%2C%20traditional%20Chinese%20architecture%2C%20mysterious%20mist%20and%20spiritual%20energy%2C%20Chinese%20manhua%20style%2C%20silver%20and%20deep%20blue%20lighting%2C%20poetic%20atmosphere%2C%20widescreen%20composition&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '完美世界：一粒尘可填海',
    desc: '石昊崛起于大荒，独断万古横推九天十地。玄幻巅峰之作，全集漫画完整版免费阅读，下拉式体验一气呵成。',
    tag: '玄幻热血',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20young%20warrior%20standing%20on%20a%20mountain%20peak%20overlooking%20a%20vast%20fantasy%20world%2C%20golden%20sunrise%20lighting%2C%20Chinese%20manhua%20style%2C%20epic%20landscape%20with%20floating%20islands%20and%20waterfalls%2C%20heroic%20silhouette%2C%20warm%20and%20majestic%20atmosphere%2C%20widescreen&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '伍六七：最强刺客的日常',
    desc: '失忆刺客剪刀手伍六七，在小鸡岛上接各种奇葩任务。搞笑热血神作，漫画完整版让人笑中带泪，下拉一口气看完。',
    tag: '搞笑热血',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20colorful%20tropical%20island%20scene%20with%20a%20funny%20assassin%20in%20hoodie%20holding%20scissors%2C%20bright%20sunny%20beach%20background%2C%20Chinese%20animation%20style%2C%20cheerful%20and%20playful%20vibe%2C%20warm%20vibrant%20colors%2C%20wide%20composition%2C%20comedic%20atmosphere&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
  {
    title: '一念永恒：白小纯的修仙路',
    desc: '怕死的白小纯踏上修仙之路，从炼药炸炉到名震天下。爆笑修仙漫画全卷完结，下拉式阅读笑到停不下来。',
    tag: '修仙搞笑',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20humorous%20cultivation%20scene%20with%20a%20young%20disciple%20causing%20an%20alchemy%20explosion%2C%20colorful%20magical%20effects%2C%20ancient%20Chinese%20temple%20background%2C%20Chinese%20manhua%20style%2C%20bright%20and%20playful%20lighting%2C%20comical%20expression%2C%20wide%20composition&width=800&height=500&seq=carousel-06&orientation=landscape',
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            重磅专题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            热门漫画完结版深度推荐，下拉阅读尽享全集
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {carouselItems.map((item, idx) => (
            <div key={idx} className="bg-background-50 rounded-xl overflow-hidden flex flex-col sm:flex-row group cursor-pointer">
              <div className="sm:w-[200px] h-48 sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={`${item.title}专题推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 p-5 flex flex-col justify-center">
                <span className="inline-block px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-2 self-start">
                  {item.tag}
                </span>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}